import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { StarRating, Typography } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import appleBadge from './images/apple-badge.svg';
import appleStore from './images/apple-store.png';
import googleBadge from './images/google-badge.png';
import googleStore from './images/google-store.png';
import {
    generateAppleStoreUrl,
    generateGooglePlayStoreUrl,
} from '../../../urls';

import styles from './AppRatings.scss';

const data = [
    {
        badge: appleBadge,
        getHref: generateAppleStoreUrl,
        icon: appleStore,
        id: 'app-store',
        stars: 5,
    },
    {
        badge: googleBadge,
        getHref: generateGooglePlayStoreUrl,
        icon: googleStore,
        id: 'google-play',
        stars: 4.5,
    },
];

function AppRatings(props) {
    const {
        campaign,
        t,
    } = props;

    return (
        <div className={styles.container}>
            {data.map(({
                badge, getHref, icon, id, stars,
            }) => (
                <div key={id}>
                    <A
                        aria-label={t(`${id}-download-badge`)}
                        className={styles.link}
                        href={getHref(campaign)}
                        rel="noopener noreferrer"
                        target="_blank"
                        native
                    >
                        <img className={styles.badge} src={badge} />
                        <img className={styles.icon} src={icon} />
                    </A>

                    <StarRating
                        className={styles.starRating}
                        hoverEffects="none"
                        id={`${id}-rating`}
                        rating={stars - 1}
                        starClassNames={{
                            base: styles.stars,
                            isSelected: styles.starIsSelected,
                        }}
                    />

                    <Typography id={`${id}-rating`} variant="body2">{t(`${id}-rating`)}</Typography>
                    <Typography variant="body2">{t(`${id}-review-count`)}</Typography>
                </div>
            ))}
        </div>
    );
}

AppRatings.propTypes = {
    campaign: PropTypes.string,
    t: PropTypes.func,
};

export default localize(AppRatings, ['t'], 'baseApp');
